
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'GalleryOutline'
})
export default class GalleryOutline extends Vue {}
